import Vue      from 'vue'
import Vuex     from 'vuex'
import app      from './app'
import socket   from './socket'
import vars     from './vars'
import localForage from 'localforage'
import VuexPersist from 'vuex-persist'

const vuexLocal = new VuexPersist({
  key: 'vuex',
  storage: localForage,
  modules: ['app', 'socket'],
  asyncStorage: true
});

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app    : { ...app },
    socket : { ...socket },
    vars   : { ...vars }
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js